// Thin composition layer - re-exports from focused sub-modules
import { CookieService } from './cookie.service';

import {
  campaignFilterOptions, prepareFilterOptions, getTodaysDate,
  getSource, getChannels, getPartnerString, concatenateDotsInString,
  getSubmittedVersion, hasNonEmptyValue, getStatusColor
} from './api-helpers';

import {
  getUserProfile, getTaxonomy, getClientCodes, getMediaOpsClientProfile,
  getOrphanedDeliveredData, mapOrphanedDeliveredData, globalSearch
} from './client-api';

import {
  getPlacements, searchPlacements, updatePlacement,
  movePlacement, createPlacement, deletePlacement
} from './placement-api';

import {
  campaignSync, campaignSyncStatus, placementSyncV2,
  getPlatformCampaign, mapPlatformCampaign
} from './sync-api';

import {
  getCampaignData, getCampaignDataAggrid, sortCampaigns,
  searchCampaign, updateCampaign, sendCampaignToMediaOcean,
  getCampaignDataById, mergeCampaigns, unmergeCampaigns,
  prepareCampaignData, prepareCampaignDataForClientCode,
  createCampaignNestedData, fetchCount, sortCampaignsAggrid,
  searchCampaignsAggrid, transformDataAggrid, setCampaignsData
} from './campaign-api';

// auth ansid (computed once at module load)
const search = window.location.search;
const params = new URLSearchParams(search);
let ansid = params.get('ANsid');
const AnsidCookie = CookieService.getCookie("ANsid");
if (!ansid && AnsidCookie) {
  ansid = AnsidCookie;
}
export let authansid = ansid;

// backward-compatible service object
export const MediaOpsService = {
  campaignSentToMediaOcean: '',

  // api-helpers
  campaignFilterOptions,
  prepareFilterOptions,
  getTodaysDate,
  getSource,
  getChannels,
  getPartnerString,
  concatenateDotsInString,
  getSubmittedVersion,
  hasNonEmptyValue,
  getStatusColor,

  // client-api
  getUserProfile,
  getTaxonomy,
  getClientCodes,
  getMediaOpsClientProfile,
  getOrphanedDeliveredData,
  mapOrphanedDeliveredData,
  globalSearch,

  // placement-api
  getPlacements,
  searchPlacements,
  updatePlacement,
  movePlacement,
  createPlacement,
  deletePlacement,

  // sync-api
  campaignSync,
  campaignSyncStatus,
  placementSyncV2,
  getPlatformCampaign,
  mapPlatformCampaign,

  // campaign-api
  getCampaignData,
  getCampaignDataAggrid,
  sortCampaigns,
  searchCampaign,
  updateCampaign,
  sendCampaignToMediaOcean,
  getCampaignDataById,
  mergeCampaigns,
  unmergeCampaigns,
  prepareCampaignData,
  prepareCampaignDataForClientCode,
  createCampaignNestedData,
  fetchCount,
  sortCampaignsAggrid,
  searchCampaignsAggrid,
  transformDataAggrid,
  setCampaignsData,
};
